import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE',
  name: 'Workspace',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  actions: ['READ', 'UPDATE', 'DESTROY'],
}

export default scope
